import { PICTO_FAITH_TAGS } from './catalog.js';
/**
 * Zolang de server nog niets zei (of zonder profiel): de nieuwe opt-in-geloofspictogrammen (Koran,
 * Kerk, Sjabbat, Synagoge, Mandir) nooit voorstellen, precies zoals vóór 0024.
 */
export const OPT_IN_NEVER = new Map(Object.keys(PICTO_FAITH_TAGS)
    .filter((id) => PICTO_FAITH_TAGS[id]?.optIn === true)
    .map((id) => [id, 'never']));
function normalize(s) {
    return s
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .replace(/[^a-z0-9 ]/g, ' ');
}
/**
 * Best passende pictogram-id voor `title`, of null. `names` = id → Nederlandse naam. Elk woord
 * van de naam dat in de titel voorkomt telt mee (volledig woord zwaar, stam van 4 letters licht);
 * bij gelijke stand wint de eerste in catalogusvolgorde. `keywords` (optioneel) telt het beste
 * zoekwoord vanaf 4 letters mee, aan het begin van een woord even zwaar als de naam. Midden in een
 * samenstelling ("Avondgebed") telt een zoekwoord alleen vanaf 5 letters en iets lichter, zodat
 * "pray" niet in "Spray" valt. Een zoekwoord dat al in de naam staat telt niet nog eens mee.
 * Een woordgroep schrijf je met een liggend streepje ("quran_lesson"): die telt als geheel, zodat
 * "Quran lesson" moskee wordt zonder dat elke "... lesson" dat wordt. Kortere zoekwoorden ("les",
 * "dua") zijn alleen voor de zoekbalk.
 *
 * 0024: `hidden` = pictogrammen die bij dit gezin uit het zicht staan (GET /v1/app/pictos). Die
 * stellen we niet voor, tenzij de titel de naam letterlijk als woord noemt ("Moskee" bij een gezin
 * dat Geen geloof koos); nieuwe opt-in-opties (Kerk, Koran, ...) nooit, zolang het gezin dat geloof
 * niet koos.
 */
export function suggestPicto(title, names, exclude = [], keywords = {}, hidden = OPT_IN_NEVER) {
    const text = normalize(title);
    if (text.trim().length < 3)
        return null;
    let best = null;
    for (const [id, name] of Object.entries(names)) {
        if (exclude.includes(id))
            continue;
        const mode = hidden.get(id);
        if (mode === 'never' || (mode === 'literal' && !namesLiterally(text, name)))
            continue;
        let score = 0;
        const nameWords = normalize(name).split(' ');
        for (const word of nameWords) {
            if (word.length < 3)
                continue;
            if (new RegExp(`(^| )${word}`).test(text))
                score += word.length + 10;
            else if (word.length >= 5 && new RegExp(`(^| )${word.slice(0, 4)}`).test(text))
                score += 4;
        }
        const extra = keywords[id];
        if (extra) {
            let kwScore = 0;
            for (const token of extra.split(/\s+/)) {
                // "quran_lesson" → "quran lesson" (normalize maakt van het streepje een spatie).
                const kw = normalize(token).trim().replace(/ +/g, ' ');
                if (kw.length < 4 || nameWords.includes(kw))
                    continue;
                if (new RegExp(`(^| )${kw}`).test(text))
                    kwScore = Math.max(kwScore, kw.length + 10);
                else if (kw.length >= 5 && !kw.includes(' ') && text.includes(kw))
                    kwScore = Math.max(kwScore, kw.length + 6);
            }
            score += kwScore;
        }
        if (score > 0 && (!best || score > best.score))
            best = { id, score };
    }
    return best ? best.id : null;
}
/** Noemt de (genormaliseerde) titel de naam van het pictogram letterlijk, aan het begin van een woord? */
function namesLiterally(text, name) {
    const n = normalize(name).trim().replace(/ +/g, ' ');
    return n.length >= 3 && new RegExp(`(^| )${n}( |$)`).test(text);
}
//# sourceMappingURL=pictoSuggest.js.map